import React from 'react';

import { useMediaQuery } from 'react-responsive';

import Jumbotron from 'components/modules/box/Jumbotron';
import Panel from 'components/modules/box/Panel';
import Paper from 'components/modules/box/Paper';
import Button from 'components/modules/button/Button';
import AccountRegistrationForm from 'components/organisms/registration/AccountRegistrationForm';
import SingleColumnTemplate from 'components/templates/SingleColumnTemplate';
import { pageTitles } from 'constants/pageTitles';
import { AccountRegistrationFormValues } from 'interfaces/registration';

const env = process.env.REACT_APP_SITE_ENV;

interface Props {
  onShowEmailRegistration: () => void;
  formValues: AccountRegistrationFormValues;
  onSubmit: (formValues: AccountRegistrationFormValues) => void;
}

const AccountRegistrationPage: React.FC<Props> = ({
  onShowEmailRegistration,
  formValues,
  onSubmit,
}) => {
  const isPC = useMediaQuery({ query: '(min-width: 640px)' });

  const margin = isPC ? '56px 0' : '0';

  const isDevEnv =
    env === 'develop' ||
    env === 'docker' ||
    env?.startsWith('pr-') ||
    env === 'qall-k8s';

  return (
    <SingleColumnTemplate>
      <div style={{ margin }}>
        <Jumbotron>
          <Paper>
            <Panel title={pageTitles.accountRegistration} $strongHeader>
              <div style={{ textAlign: 'center', marginBottom: 24 }}>
                ログインする時に必要になります。
                <br />
                お手元に控えてください。
              </div>
              <AccountRegistrationForm
                formValues={formValues}
                isPC={isPC}
                onSubmit={onSubmit}
              />
              {isDevEnv && (
                <Button
                  style={{ display: 'block', margin: '0 auto' }}
                  color="link"
                  size={isPC ? 'l' : 'm'}
                  onClick={onShowEmailRegistration}
                >
                  従来の登録画面はこちら
                </Button>
              )}
            </Panel>
          </Paper>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default AccountRegistrationPage;
